export enum PageItemType {
  API = 'API',
  COVER = 'COVER',
  CATEGORIES = 'CATEGORIES',
}
